"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpiFromLocale = exports.getLocaleFromUPI = exports.getItemByField = exports.getDisplayDate = exports.defaultUpi = exports.defaultLanguageCountry = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
var defaultLanguageCountry = 'en-US';
exports.defaultLanguageCountry = defaultLanguageCountry;
var defaultUpi = 'ENU';
exports.defaultUpi = defaultUpi;
var getLocaleFromUPI = function getLocaleFromUPI(upiLanguage) {
  var locale = '';
  switch (upiLanguage) {
    case 'CHS':
      locale = 'zh-CN';
      break;
    case 'DEU':
      locale = 'de-DE';
      break;
    case 'ENU':
      locale = 'en-US';
      break;
    case 'ESP':
      locale = 'es-ES';
      break;
    case 'FRA':
      locale = 'fr-FR';
      break;
    case 'ITA':
      locale = 'it-IT';
      break;
    case 'JPN':
      locale = 'ja-JP';
      break;
    case 'KOR':
      locale = 'ko-KR';
      break;
    case 'PTB':
      locale = 'pt-BR';
      break;
    default:
      locale = '';
  }
  return locale;
};
exports.getLocaleFromUPI = getLocaleFromUPI;
var getUpiFromLocale = function getUpiFromLocale(locale) {
  var upi = '';
  switch (locale) {
    case 'zh-CN':
      upi = 'CHS';
      break;
    case 'de-DE':
      upi = 'DEU';
      break;
    case 'es-ES':
      upi = 'ESP';
      break;
    case 'fr-FR':
      upi = 'FRA';
      break;
    case 'it-IT':
      upi = 'ITA';
      break;
    case 'ja-JP':
      upi = 'JPN';
      break;
    case 'ko-KR':
      upi = 'KOR';
      break;
    case 'pt-BR':
      upi = 'PTB';
      break;
    case 'en-US':
    default:
      upi = defaultUpi;
      break;
  }
  return upi;
};
exports.getUpiFromLocale = getUpiFromLocale;
var getItemByField = function getItemByField(field, data) {
  var result = '';
  if (data && data.response) {
    result = data.response[field];
  }
  return result;
};

/**
 * Maybe if userLocale (language) doesn't match upiLanguage of document,
 * we need to use userLocale? Testing this scenario...
 *
 * @returns localized date in the version from UPI
 */
exports.getItemByField = getItemByField;
var getDisplayDate = function getDisplayDate(upiLanguage, userLocale, date) {
  var displayDate = '';
  var locale = '';
  if (upiLanguage) {
    locale = getLocaleFromUPI(upiLanguage);
  }
  if (locale !== userLocale) {
    locale = userLocale;
  }
  var updateDate = date.split(' ').length - 1 > 1 ? date : date.trim().replace(' ', 'T');
  var isDateValid = Date.parse(updateDate);
  var formattedDate = !isNaN(isDateValid) ? new Date(updateDate) : null;
  if (formattedDate) {
    var monthFormat = locale === 'en-US' ? 'short' : 'long';
    var defaultLanguage = locale ? locale : defaultLanguageCountry;
    displayDate = Intl.DateTimeFormat(defaultLanguage, {
      year: 'numeric',
      month: monthFormat,
      day: 'numeric'
    }).format(new Date(formattedDate));
  } else {
    throw new Error("".concat(date, " is invalid"));
  }
  return displayDate;
};
exports.getDisplayDate = getDisplayDate;